<template>
  <div style="background:#01000A;">
    <v-container>
      <v-row
        justify="center"
        align="center"
        style="height:100vh"
        class="text-center white--text"
      >
        <v-col cols="12" align-self="end">
          <h1 class=" text-h3">Contact</h1>
        </v-col>
        <v-col cols="12" align-self="start">
          <p class="text-h5">comming soon</p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.text-h3,
.text-h4,
.text-body-2,
.text-body-1 {
  font-family: 'Overlock' !important;
  text-shadow: 0px 0px 24px rgba(255, 255, 255, 0.88);
}

.text-h5,
.text-h6 {
  font-family: 'Overlock' !important;
  /* line-height: 1.5rem !important; */
}
</style>
